




import { Component } from 'vue-property-decorator'
import Vue from 'vue'

@Component
export default class UnauthorizedDomain extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UnauthorizedDomain.vue